import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { SectionWrapper } from '../components/SectionWrapper';

import styles from './ResearchNextStepsSection.module.css';

const cards = [
  {
    body: 'A 30-minute mapping call with your teaching & learning office: how the AIMS interventions could apply to the courses you already run, and what the program would cost.',
    cta: 'For institutions',
    eyebrow: 'For institutions',
    href: '/institutions',
    title: 'Map this evidence to your campus.',
  },
  {
    body: 'AI-generated hints are built into every Kudu course. Start a free Kudu course in your subject in about two minutes and see how they work in your homework.',
    cta: 'For faculty',
    eyebrow: 'For faculty',
    href: '/faculty',
    title: 'Try AI hints in your own course.',
  },
  {
    body: 'This page is the canonical source for the AIMS study and Kudu\'s role in it. Stable URL. Updates tracked. Reach out if you\'d like to discuss replication or expansion studies.',
    cta: 'Contact us',
    eyebrow: 'For press & researchers',
    href: '/contact',
    title: 'Use this page as a citation.',
  },
];

export function ResearchNextStepsSection() {
  return (
    <SectionWrapper background="white" data-testid="research-section-next-steps">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>WHERE TO NEXT</p>
          <h2 className={styles.title}>Different doors for different readers.</h2>
        </div>
        <div className={styles.cards}>
          {cards.map((card) => (
            <article className={styles.card} key={card.eyebrow}>
              <div className={styles.copy}>
                <p className={styles.cardEyebrow}>{card.eyebrow}</p>
                <h3>{card.title}</h3>
                <p>{card.body}</p>
              </div>
              <Link className={styles.cta} to={card.href}>
                <span>{card.cta}</span>
                <ArrowRight aria-hidden="true" size={16} />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
